import React from 'react';
import { useParams } from 'react-router-dom';
import { getPartnerLegalInfoByShopId } from '../constants/offertaLegalByShop';

const OffertaView = () => {
  const { shopId } = useParams();
  const partnerLegalInfo = getPartnerLegalInfoByShopId(shopId);

  return (
    <div className="offerta-container">
      <h1 className="offerta-title">ПУБЛИЧНАЯ ОФЕРТА</h1>
      
      <p>
        Индивидуальный предприниматель <strong>Швора Никита Сергеевич</strong> (ОГРНИП 325774600725439), 
        именуемый в дальнейшем <strong>Исполнитель</strong>, являющийся владельцем и оператором сервиса{' '}
        <strong>RCoffee</strong>, настоящим предлагает неопределенному кругу лиц заключить 
        договор на изложенных ниже условиях. Настоящий документ является публичной офертой в смысле 
        статьи 437(2) Гражданского кодекса РФ.
      </p>

      <h2 className="offerta-section">1. Термины и определения</h2>

      <p>В настоящей Оферте нижеперечисленные термины используются в следующих значениях:</p>

      <p>
        <strong>Исполнитель</strong> – индивидуальный предприниматель Швора Никита Сергеевич, 
        владелец и оператор сервиса RCoffee, предоставляющий Пользователям доступ 
        к функциональности указанного сервиса.
      </p>

      <p>
        <strong>Пользователь</strong> – дееспособное физическое лицо, присоединившееся к настоящей 
        Оферте в целях использования сервиса RCoffee для оформления Заказов.
      </p>

      <p>
        <strong>Сервис RCoffee</strong> (далее – <strong>Сервис</strong>) – программный 
        сервис (мини-приложение (бот) в мессенджере Telegram), предоставляющий Пользователю возможность 
        дистанционно:
      </p>

      <ul>
        <li>выбрать одну из доступных на электронной карте Партнерских кофеен;</li>
        <li>просмотреть меню выбранной кофейни и выбрать товар из ассортимента;</li>
        <li>оплатить заказ через встроенную в Сервис платежную систему;</li>
        <li>получить после успешной оплаты уникальный QR-код, по которому можно получить 
        заказанный товар в выбранной кофейне, но не ранее чем через 15 минут после оформления Заказа.</li>
      </ul>

      <p>
        <strong>Партнерская кофейня (также Продавец)</strong> – организация общественного питания (кофейня) 
        или индивидуальный предприниматель, заключивший с Исполнителем соглашение об участии в Сервисе. 
        Партнерская кофейня непосредственно изготавливает и реализует Пользователю заказанный Товар и 
        несет ответственность за надлежащее исполнение Заказа.
      </p>

      <p>
        <strong>Товар</strong> – напиток (кофе или иной напиток) и/или иной товар из ассортимента 
        Партнерской кофейни, доступный для заказа через Сервис.
      </p>

      <p>
        <strong>Заказ</strong> – оформленный с помощью Сервиса запрос Пользователя на приобретение 
        выбранного Товара в указанной Партнерской кофейне, сопровождаемый предварительной оплатой. 
        После успешного оформления и оплаты Заказа Пользователю предоставляется уникальный QR-код, 
        подтверждающий принятие Заказа к исполнению.
      </p>

      <p>
        <strong>QR-код</strong> – уникальный двухмерный штриховой код, формируемый Сервисом после оплаты 
        Заказа, содержащий информацию о Заказе. QR-код предъявляется Пользователем в кофейне для 
        получения оплаченного Товара.
      </p>

      <p>
        <strong>Акцепт Оферты</strong> – полное и безоговорочное принятие Пользователем условий настоящей 
        Оферты путем совершения действий, указанных в разделе 3 настоящей Оферты. Акцепт Оферты означает 
        заключение юридически обязательного договора между Пользователем и Исполнителем на условиях 
        настоящей Оферты.
      </p>

      <h2 className="offerta-section">2. Предмет договора</h2>

      <p>
        <strong>2.1.</strong> Исполнитель обязуется предоставить Пользователю услуги по обеспечению возможности использования 
        Сервиса RCoffee с целью выбора Партнерской кофейни и Товара, оформления и оплаты Заказа, 
        а также получения подтверждения заказа (QR-кода). Пользователь вправе с помощью Сервиса оформить 
        Заказ на выбранный Товар в выбранной кофейне и обязуется оплатить заказанный Товар в порядке, 
        предусмотренном настоящей Офертой.
      </p>

      <p>
        <strong>2.2.</strong> Исполнитель не является изготовителем или продавцом Товаров, доступных для заказа через Сервис. 
        Функции Исполнителя ограничены предоставлением Пользователю технической возможности взаимодействия с Продавцом (кофейней) 
        для дистанционного оформления и оплаты Заказа. Непосредственное изготовление и отпуск (передача) 
        Товара Пользователю осуществляются соответствующей Партнерской кофейней, которая заключает с 
        Пользователем договор розничной купли-продажи на приобретаемый Товар в момент оформления Заказа.
      </p>

      <p>
        <strong>2.3.</strong> Оплата Пользователем Товара через Сервис производится с использованием интегрированной платежной системы.
        Исполнитель при приёме оплаты действует в интересах и от имени Продавца на основании договорных отношений с ним 
        (агент, оператор по приёму платежей). 
        Обязательство Пользователя по оплате перед Продавцом считается исполненным с момента успешного завершения платежной транзакции 
        в Сервисе. После оплаты Заказа Исполнитель предоставляет Пользователю подтверждение в виде QR-кода или номера заказа,
        который должен быть предъявлен в кофейне для получения товара.
      </p>

      <h2 className="offerta-section">3. Порядок заключения договора (Акцепт)</h2>

      <p>
        <strong>3.1.</strong> Текст настоящей Оферты размещён в интерфейсе Сервиса и доступен 
        Пользователю для ознакомления перед оформлением Заказа. 
        Настоящая Оферта не требует подписи и действует в электронном виде.
      </p>

      <p>
        <strong>3.2.</strong> Совершение Пользователем любых действий, свидетельствующих о намерении воспользоваться 
        Сервисом (в том числе нажатие кнопки «Начать», регистрация в Сервисе, оформление Заказа и/или осуществление оплаты), 
        означает полное и безоговорочное принятие Пользователем условий Оферты. 
        Акцептом Оферты в любом случае считается оплата Пользователем оформленного в Сервисе Заказа.
      </p>

      <p>
        <strong>3.3.</strong> С момента Акцепта Оферты Пользователем между Исполнителем и Пользователем заключается договор на 
        условиях настоящей Оферты (ст. 438 ГК РФ). Пользователь, принявший Оферту, обязуется соблюдать условия настоящего договора. 
        Если Пользователь не согласен с каким-либо условием, он не вправе осуществлять Акцепт и пользоваться функционалом Сервиса.
      </p>

      <h2 className="offerta-section">4. Оформление и оплата Заказа</h2>

      <p>
        <strong>4.1.</strong> Пользователь осуществляет выбор Партнерской кофейни из числа доступных в Сервисе, 
        исходя из местоположения кофейни и других предоставленных сведений. Исполнитель не гарантирует постоянную доступность 
        любой кофейни в Сервисе; перечень Партнерских кофеен может меняться.
        
        Информация о Партнерских кофейнях, включая наименование, местоположение, режим работы, меню, описание Товаров, 
        размещается в Сервисе в ознакомительных целях и предоставляется самими кофейнями. 
        Исполнитель не гарантирует точность, полноту и актуальность этих сведений и не несет ответственности за любые 
        последствия, вызванные их недостоверностью.
      </p>

      <p>
        <strong>4.2.</strong> Пользователь выбирает желаемый Товар из меню выбранной кофейни через интерфейс Сервиса. 
        Вся информация о доступных Товарах (описание, состав, цена, наличие и пр.) предоставляется Партнерскими кофейнями. 
        Исполнитель стремится обеспечивать актуальность этой информации, однако не несет ответственности за ее достоверность, 
        соответствие действительности и за возможные изменения, внесенные Продавцом.
      </p>

      <p>
        <strong>4.3.</strong> Актуальная стоимость Товаров (включая все применимые налоги и сборы) указывается непосредственно в интерфейсе
        Сервиса на момент оформления Заказа и является обязательной для сторон с момента Акцепта.
        Информация о ценах формируется и предоставляется соответствующей Партнерской кофейней. Исполнитель не устанавливает
        и не контролирует стоимость Товаров, а также не несет ответственности за возможное изменение цен или за
        достоверность сведений, размещённых Продавцом.
        Публикация информации о цене Товара в Сервисе признается надлежащим способом информирования Пользователя.
      </p>

      <p>
        <strong>4.4.</strong> Сервис может предоставлять Пользователю возможность оформления Заказа с указанием желаемого времени
        получения Товара (предзаказ). В случае выбора такой опции Пользователь самостоятельно указывает предполагаемое
        время визита в кофейню, при этом обязуется прибыть в указанное время или в пределах допустимого интервала, 
        отображенного в Сервисе. Конкретные временные параметры исполнения Заказа определяются функционалом и
        настройками кофейни.
      </p>

      <p>
        <strong>4.5.</strong> После формирования списка выбранных позиций Пользователь подтверждает Заказ
        и осуществляет его оплату через встроенную платежную систему. Оплата производится банковской картой.
      </p>

      <p>
        <strong>4.6.</strong> По успешной оплате Заказа Пользователь получает электронное подтверждение – уникальный QR-код, 
        который должен быть предъявлен сотруднику кофейни при получении Заказа.
      </p>

      <p>
        <strong>4.7.</strong> Пользователь может получить заказанный Товар в выбранной кофейне не ранее чем через 15 минут после оформления Заказа.
      </p>

      <p>
        <strong>4.8.</strong> Выдача Товара производится сотрудником кофейни после проверки QR-кода и/или номера заказа.
        Пользователь должен убедиться в соответствии полученного Товара своему Заказу.
      </p>

      <p>
        <strong>4.9.</strong> Если выбранная кофейня не может выполнить Заказ, Исполнитель уведомляет Пользователя, и средства будут возвращены.
      </p>

      <h2 className="offerta-section">5. Отмена Заказа и возврат средств</h2>

      <p>
        <strong>5.1.</strong> Пользователь вправе отменить оформленный Заказ до получения Товара. Отмена Заказа осуществляется посредством соответствующей функции в интерфейсе Сервиса (например, кнопка «Отменить заказ» в меню заказа) либо путем обращения в службу поддержки Исполнителя. Если Заказ уже оплачен, при отмене Пользователю возвращаются уплаченные средства за вычетом расходов на обработку платежа (комиссий платежных систем, если таковые невозвратны).
      </p>

      <p>
        <strong>5.2.</strong> В случае отмены Заказа Пользователем до начала приготовления Товара кофейней, возврат осуществляется в размере 100% уплаченной суммы. Если к моменту отмены Продавец уже начал исполнение (приготовление) заказа, возможность и условия возврата денежных средств определяются правилами соответствующей кофейни. Как правило, при отмене на позднем этапе приготовления Товара фактически понесенные Продавцом затраты могут быть удержаны из суммы возврата (либо возврат может не производиться, если товар уже изготовлен и не может быть реализован повторно). Исполнитель, со своей стороны, приложит усилия для урегулирования вопроса возврата, однако не гарантирует полного возврата в этой ситуации.
      </p>

      <p>
        <strong>5.3.</strong> Если заказ не может быть выполнен по причинам, зависящим от кофейни (например, кофейня не смогла вовремя приготовить заказ, закрылась раньше времени, возникла неполадка оборудования и т.п.), Заказ подлежит отмене, о чем Пользователю направляется уведомление через Сервис. В этом случае Пользователю возвращается полная стоимость оплаченного Заказа. Дополнительная компенсация (штраф, неустойка) за отмену Заказа по вине кофейни настоящей Офертой не предусмотрена.
      </p>

      <p>
        <strong>5.4.</strong> В случае получения Пользователем Товара ненадлежащего качества (например, неправильный заказ, испорченный или не соответствующий описанию Товар) Пользователь вправе обратиться через Сервис в поддержку с требованием о возврате денежных средств либо замене Товара. Рассмотрение претензий по качеству осуществляет Продавец (кофейня). Исполнитель переадресует претензию Пользователя соответствующей кофейне и способствует оперативному рассмотрению. В случае признания претензии обоснованной, Продавец самостоятельно осуществляет возврат денежных средств Пользователю либо предоставляет замену (по соглашению с Пользователем). Возврат денежных средств в таких ситуациях может осуществляться через ту же платежную систему, которая использовалась Пользователем при оплате, на ту же банковскую карту или счет, с которого была произведена оплата.
      </p>

      <p>
        <strong>5.5.</strong> Если Пользователю положен возврат денежных средств согласно условиям настоящей Оферты, такой возврат, как правило, производится тем же способом, которым была произведена оплата (на банковскую карту или счет Пользователя). Сроки возврата зависят от правил платежной системы и банка-эмитента карты и могут составлять до 5–10 рабочих дней с момента одобрения возврата. Исполнитель со своей стороны совершает необходимые действия по инициированию возврата незамедлительно, однако не несет ответственности за возможные задержки по вине платежных систем или банков.
      </p>

      <h2 className="offerta-section">6. Права и обязанности сторон</h2>

      <p>
        <strong>6.1. Обязанности Исполнителя:</strong>
        <ul>
            <li>Обеспечить функционирование Сервиса RCoffee и возможность Пользователю оформлять Заказы в соответствии с условиями настоящей Оферты.</li>
            <li>Передавать сведения о оформленных Пользователем Заказах соответствующим Партнерским кофейням и обеспечивать их получение кофейнями (через автоматизированную систему или иным согласованным с кофейней способом).</li>
            <li>Обеспечивать Пользователя информацией о статусе Заказа (принят, готовится, готов к получению и т.п.) в рамках возможностей Сервиса.</li>
            <li>Предоставлять Пользователю консультационную и техническую поддержку по вопросам работы Сервиса (через предусмотренные каналы связи, например, поддержку в Telegram или по электронной почте).</li>
            <li>В случае получения от Пользователя претензий, связанных с качеством или исполнением заказа, перенаправлять такие претензии соответствующему Продавцу и содействовать их скорейшему урегулированию.</li>
        </ul>
      </p>
      <p>
        <strong>6.2. Права Исполнителя:</strong>
        <ul>
            <li>Отказывать в регистрации или использовании Сервиса Пользователям, нарушающим условия настоящей Оферты, либо по требованию законодательства.</li>
            <li>Приостанавливать либо прекращать доступ Пользователя к Сервису в случае нарушения Пользователем положений настоящей Оферты, а также в случае обнаружения признаков мошеннических действий (например, попытки неоправданного отзыва платежа (чарджбэк) после получения Товара, предоставление ложной информации при регистрации и пр.).</li>
            <li>Отменять Заказы Пользователя в случае невозможности их исполнения (см. п. 4.7 и п. 5.3), а также в случае выявления технической ошибки в отображении информации о Товаре или цене. В случае отмены по таким основаниям Исполнитель возвращает Пользователю уплаченную сумму.</li>
            <li>Обновлять, изменять функционал Сервиса, приостанавливать работу Сервиса для проведения технического обслуживания, а также вносить изменения в настоящую Оферту в порядке, установленном разделом 9 ниже.</li>
            <li>Получать вознаграждение от Продавцов (кофеен) за оказание услуг агрегирования (предоставление Сервиса). Взимать с Пользователя плату за пользование Сервисом Исполнитель не вправе (Пользователь оплачивает только заказанные Товары по ценам, установленным Продавцом).</li>
        </ul>
      </p>
      <p>
        <strong>6.3. Обязанности Пользователя:</strong>
        <ul>
            <li>Предоставлять при использовании Сервиса достоверные данные о себе, необходимые для оформления Заказа (например, указывать свои имя и контактный телефон при необходимости).</li>
            <li>Оплатить оформленный Заказ в размере и порядке, определенных настоящей Офертой, до получения Товара.</li>
            <li>Лично явиться в выбранную кофейню для получения заказанного Товара не ранее чем через 15 минут после оформления заказа и в течение разумного времени (до закрытия кофейни в день заказа), предъявить полученный QR-код сотруднику кофейни и забрать Товар.</li>
            <li>Обеспечить сохранность и конфиденциальность полученного QR-кода и/или номера зказа. Не допускать его утраты или копирования третьими лицами до получения Товара. Все последствия использования QR-кода и/или номера заказа третьими лицами (получения ими Товара по коду) несет Пользователь.</li>
            <li>Не использовать Сервис в незаконных целях; не пытаться получить несанкционированный доступ к чужим данным или функционалу Сервиса; не совершать действий, способных нарушить нормальную работу Сервиса (включая запрет на использование вредоносных программ, скриптов, автоматизированных запросов и т.п.).</li>
            <li>Ознакомиться с условиями настоящей Оферты до совершения Акцепта и регулярно проверять актуальную редакцию Оферты при продолжении использования Сервиса.</li>
        </ul>
      </p>
      <p>
        <strong>6.4. Права Пользователя: </strong>
        <ul>
        <li>Пользоваться функционалом Сервиса RCoffee для поиска кофеен, ознакомления с информацией о Товарах, оформления Заказов и оплаты на условиях настоящей Оферты.</li>
        <li>Требовать от Исполнителя исполнения его обязанностей по настоящему договору, включая своевременную передачу информации о Заказе кофейне и предоставление QR-кода и/или номера заказа после оплаты.</li>
        <li>Обращаться в службу поддержки Исполнителя по возникающим вопросам, связанным с использованием Сервиса или выполнением Заказов.</li>
        <li>Отменить Заказ и потребовать возврат средств в случаях и порядке, предусмотренных разделом 5 настоящей Оферты.</li>
        <li>В случае нарушения своих прав со стороны Продавца (кофейни) – защищать свои права и законные интересы в соответствии с законодательством РФ (включая Закон РФ «О защите прав потребителей»), направляя соответствующие претензии через Сервис или непосредственно Продавцу.</li>

        </ul>
      </p>
      
      <p>
        <strong>6.5.</strong> Сервис предоставляется Пользователю на условиях «как есть» (<em>as is</em>). Исполнитель не гарантирует бесперебойную и безошибочную работу Сервиса, его совместимость с программным обеспечением или устройствами Пользователя. В случае технических сбоев, затрудняющих использование Сервиса (в том числе невозможность оформить Заказ, произвести оплату или получить QR-код), Исполнитель обязуется устранить такие неполадки в разумные сроки, однако не несет ответственности за возможные убытки Пользователя, возникшие вследствие таких сбоев.
      </p>
      <p>
        <strong>6.6.</strong> Пользователь обязуется не использовать Сервис в автоматическом режиме (в том числе с применением программных роботов, скриптов и иных автоматизированных средств) и не создавать множественные Заказы в обход установленных Сервисом ограничений. В случае выявления признаков злоупотребления или мошеннической активности, Исполнитель вправе заблокировать доступ Пользователя к Сервису и аннулировать Заказы без компенсации.
      </p>



      <h2 className="offerta-section">7. Ответственность сторон</h2>

      <p>
        <strong>7.1.</strong> Исполнитель несет ответственность перед Пользователем исключительно за надлежащее выполнение своих обязательств, прямо предусмотренных настоящей Офертой. Исполнитель не отвечает за качество, соответствие описанию, комплектность и потребительские свойства Товара, а равно за своевременность изготовления и передачи Товара Пользователю – эти обязательства несет Продавец (Партнерская кофейня). Любые претензии, связанные с недостатками Товара или нарушением сроков исполнения Заказа, должны предъявляться непосредственно Продавцу. Исполнитель со своей стороны оказывает Пользователю содействие в передаче и рассмотрении таких претензий (как указано в п. 6.1), однако не несет обязанности удовлетворять требования, связанные с недостатками Товара или оказанием услуги общественного питания, вместо Продавца.
      </p>

      <p>
        <strong>7.2.</strong> Исполнитель не несет ответственности за неисполнение или ненадлежащее исполнение обязательств по настоящему договору, если это вызвано обстоятельствами, находящимися вне разумного контроля Исполнителя. К таким обстоятельствам относятся, в том числе, сбои в работе телекоммуникационных и энергосетей, сбои программного обеспечения или оборудования сторонних организаций, технические неполадки мессенджера Telegram или платежных систем, действия государственных органов, пожар, наводнение, землетрясение и иные форс-мажорные обстоятельства (подробнее – раздел 8 ниже).
      </p>

      <p>
        <strong>7.3.</strong> Исполнитель не несет ответственности за возможные убытки Пользователя, возникшие в результате невозможности использования Сервиса (простои, упущенная выгода, иные косвенные убытки), а также за действия третьих лиц, повлекшие ущерб для Пользователя при использовании Сервиса (в том числе несанкционированное использование аккаунта или QR-кода или номера заказа Пользователя третьими лицами, не по вине Исполнителя).
      </p>

      <p>
        <strong>7.4.</strong> В любом случае размер ответственности Исполнителя перед Пользователем ограничен суммой, равной стоимости Заказа, по поводу которого возникли претензии. Возмещение упущенной выгоды исключается. Данное ограничение ответственности применяется в максимальной степени, допускаемой применимым законодательством.
      </p>

      <p>
        <strong>7.5.</strong> В случае нарушения Пользователем своих обязательств, установленных настоящей Офертой, либо требований законодательства, Пользователь несет ответственность, предусмотренную законодательством РФ и договором. За нарушение условий оплаты Заказа, неправомерный отзыв транзакции оплаты после получения Товара, разглашение QR-кода, номера заказа или иные противоправные действия, повлекшие ущерб, Пользователь обязан возместить Исполнителю или Продавцу понесенные убытки. Исполнитель вправе требовать такого возмещения в судебном порядке.
      </p>


      <h2 className="offerta-section">8. Форс-мажор</h2>

      <p>
        <strong>8.1.</strong> Стороны освобождаются от ответственности за частичное или полное неисполнение своих обязательств по договору, если оно явилось следствием чрезвычайных и непредотвратимых обстоятельств, возникших после заключения договора и находящихся вне контроля Сторон (форс-мажор). К таким обстоятельствам относятся стихийные бедствия, пожары, техногенные аварии, военные действия, террористические акты, решения государственных органов, сбои в работе глобальных сетей и систем связи, отключения электропитания и другие подобные события.
      </p>

      <p>
        <strong>8.2.</strong> Сторона, для которой исполнение обязательств оказалось невозможным вследствие форс-мажора, должна уведомить другую Сторону в разумный срок через доступные средства связи. После прекращения действия форс-мажорных обстоятельств выполнение обязательств возобновляется на прежних условиях, если Стороны не договорятся о ином.
      </p>
       
      <h2 className="offerta-section">9. Заключительные положения</h2>

      <p>
        <strong>9.1. </strong>Настоящая Оферта вступает в силу с момента ее публикации и действует до момента ее отзыва Исполнителем. Исполнитель вправе в любое время внести изменения в условия Оферты или отозвать Оферту по своему усмотрению. Изменения условий Оферты публикуются тем же способом, каким была опубликована настоящая Оферта (либо доводятся до сведения Пользователей посредством интерфейса Сервиса). Измененная Оферта вступает в силу с момента ее опубликования, если иное не оговорено дополнительно.
      </p>

      <p>
        <strong>9.2. </strong>Пользователь обязуется самостоятельно отслеживать изменения в Оферте. Продолжение использования Сервиса после внесения изменений означает согласие Пользователя с новой редакцией Оферты. В случае несогласия с изменениями Пользователь должен прекратить использование Сервиса.
      </p>

      <p>
        <strong>9.3. </strong>Договор, заключаемый посредством Акцепта настоящей Оферты, считается заключенным на неопределенный срок. Пользователь вправе прекратить пользование Сервисом и расторгнуть договор в одностороннем порядке в любое время (при отсутствии неисполненных Заказов), удалив/деактивировав свой аккаунт либо прекратив использование Сервиса. Исполнитель вправе в одностороннем внесудебном порядке расторгнуть договор с Пользователем (или временно приостановить его исполнение) в случае нарушения Пользователем условий Оферты, блокировав доступ Пользователя к Сервису.
      </p>

      <p>
        <strong>9.4. </strong>Недействительность какого-либо из положений настоящей Оферты не влечет недействительности остальных положений договора. В случае если какое-либо условие признано недействительным в судебном порядке, Стороны заменят такое положение другим, юридически действительным, максимально приближенным по смыслу к первоначальному.
      </p>

      <p>
        <strong>9.5. </strong>Во всем остальном, что не предусмотрено настоящей Офертой, Стороны руководствуются действующим законодательством Российской Федерации. Настоящий договор регулируется нормами российского права. Все споры, разногласия или требования, возникающие из настоящей Оферты или в связи с ее исполнением, подлежат разрешению путем переговоров. При невозможности достичь соглашения спор передается на рассмотрение компетентного суда по месту нахождения Исполнителя, если иной порядок подсудности не установлен законодательством РФ.
      </p>

      <h2 className="offerta-section">10. Реквизиты и контактная информация Исполнителя</h2>

      <div className="offerta-legal-grid">
        <div className="offerta-info-box">
          <p><strong>Исполнитель:</strong></p>
          <p>Индивидуальный предприниматель Швора Никита Сергеевич</p>
          <p><strong>ОГРНИП:</strong> 325774600725439</p>
          <p><strong>Электронная почта:</strong> nikshvora@gmail.com</p>
          <p>(для связи и направления претензий)</p>
        </div>
        <div className="offerta-info-box">
          <p><strong>Партнерская кофейня:</strong></p>
          <p>{partnerLegalInfo.legalEntityName}</p>
          <p><strong>ОГРНИП:</strong> {partnerLegalInfo.ogrnip}</p>
          <p><strong>Электронная почта:</strong> {partnerLegalInfo.email}</p>
          <p>{partnerLegalInfo.supportNote}</p>
        </div>
      </div>

      <div className="offerta-footer">
        © 2026 RCoffee. Все права защищены.
      </div>
    </div>
  );
};

export default OffertaView;
